<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px" v-show="mostrarFormulario">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Datos</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12 text-center">
            <img
              :src="model.Image"
              class="rounded-circle"
              @click="misImagenes"
              :style="profileImageStyle"
              alt
            />
            <img
              v-if="!isAssociatedCommerce"
              src="/img/ico_camera_profile.png"
              style="width:40px;height:40px;vertical-align: bottom;margin-left: -39px;"
            />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>CUIT</label>
            <base-input v-model="model.CUIT" readonly></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Nombre</label>
            <base-input v-model="model.Name" placeholder="Ejemplo: Nombre y Apellido" :readonly="isAssociatedCommerce"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Razón social</label>
            <base-input v-model="model.BusinessName" placeholder="Ejemplo: Las Tres Marías" :readonly="isAssociatedCommerce"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-10">
            <label>Mail</label>
            <base-input
              v-model="model.Mail"
              name="email"
              placeholder="Ejemplo: mail@mail.com"
              readonly
            ></base-input>
            <!-- <span class="validation-error">{{ errors.first('email') }}</span> -->
          </div>

          <div class="col-xl-2" style="display: flex; align-items:center; padding-top: 10px;" v-if="!isAssociatedCommerce">            
            <b-button variant="outline-success" class="btnValidar" style="width:100% !important" @click="emailValidation">Cambiar</b-button>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Localidad</label>
            <base-input
              v-if="isAssociatedCommerce"
              v-model="model.CityName"
              readonly
            ></base-input>
            <KitsBusquedaSimple
              v-else
              url="City/GetTopByText"
              v-model="Localidad"
              :currentValue="Localidad"
            />
          </div>
        </div>

        <!-- LOCALIDAD -->

        <div class="row form-group">
          <div class="col-md-12">
            <label>Calle</label>
            <base-input v-model="model.Street" placeholder="Escribí la calle" :readonly="isAssociatedCommerce"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Número</label>
            <base-input v-model="model.StreetNumber" placeholder="Escribí el número de dirección" :readonly="isAssociatedCommerce"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Piso</label>
            <base-input v-model="model.Floor" :readonly="isAssociatedCommerce"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Departamento</label>
            <base-input v-model="model.Department" :readonly="isAssociatedCommerce"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Actividad comercial</label>
            <KitsCombo
              v-model="model.ComercialActivityID"
              v-bind:items="actividadescomerciales"
              propertyName="Name"
              propertyID="EntityID"
              nullText=" -- Seleccione actvidad comercial -- "
              :todos="true"
              :disabled="isAssociatedCommerce"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Tipo de IVA</label>
            <KitsCombo
              v-model="model.IvaTypeID"
              v-bind:items="tiposiva"
              propertyName="Name"
              propertyID="EntityID"
              nullText=" -- Seleccione un tipo de iva -- "
              :todos="true"
              :disabled="isAssociatedCommerce"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Compañia</label>
            <KitsCombo
              v-model="model.TelephoneCompanyID"
              v-bind:items="companias"
              propertyName="Name"
              propertyID="EntityID"
              nullText=" -- Seleccione un compañía -- "
              :todos="true"
              :disabled="isAssociatedCommerce"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-3">
            <label>Prefijo</label>
            <base-input v-model="model.Prefix" type="number" onlyNumbers :maxlength="5" readonly></base-input>
          </div>
          <div class="col-md-7">
            <label>Número</label>
            <base-input v-model="model.Telephone" readonly></base-input>
          </div>
          <div class="col-xl-2" style="display: flex; align-items:center; padding-top: 10px;" v-if="!isAssociatedCommerce">            
            <b-button variant="outline-danger" class="btnValidar" style="width:100% !important" v-if="!isPhoneVerify" @click="phoneValidation">Validar</b-button>
            <b-button variant="outline-success" class="btnValidar" style="width:100% !important" v-else @click="phoneValidation">Cambiar</b-button>
          </div>
        </div>        

        <div class="row form-group" v-if="!isAssociatedCommerce">
          <div class="col-md-12 text-center">
            <save-button @click="pinValidate"></save-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <pin-validation ref="pin-validation"
        :showModal.sync="showModalPinValidation"
        v-on:validPin="onValidPin"
        v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation>
  </div>
</template>

<style scoped>
    @media (min-width: 1200px) {
      .btnValidar{
        margin-left:50px;
      }
    }
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import PinValidation from '@/views/Pin/PinValidation';

export default {
  components: { KitsCombo, KitsBusquedaSimple, "pin-validation": PinValidation},  
  data() {
    return {
      model: {
        AccountID: null,
        CityID: null,
        CityName: "",
        Street: "",
        StreetNumber: "",
        Floor: "",
        Department: "",
        Name: "",
        BusinessName: "",
        Lat: "",
        Long: "",
        ComercialActivityID: null,
        CUIT: "",
        LandLane: "",
        TelephoneCompanyID: null,
        IvaTypeID: null,
        Prefix: "",
        Telephone: "",
        Image: "",
        Mail: ""
      },
      actividadescomerciales: [],
      tiposiva: [],
      companias: [],
      Localidad: null,
      isPhoneVerify: false,
      usePaymentPin: false,
      showModalPinValidation: false,
      OldMail: "",
      mostrarFormulario: false
    };
  },
  methods: {
    misImagenes() {
      if (this.isAssociatedCommerce) {
        return;
      }

      this.$router.push("misimagenes");
    },
    guardar() {
      let context = this;

      if (context.isAssociatedCommerce) {
        return;
      }

      if (this.numerocompleto.length != 0 && this.numerocompleto.length != 10) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El Prefijo y el Numero deben sumar 10 dígitos",
          context
        );
        return;
      }

      this.$validator.validate().then(valid => {
        if (valid) {
          axiosHelpers.axiosPost(
            "Commerce/MyProfileSave",
            {
              CityID: context.Localidad != null ? context.Localidad.ID : 0,
              Street: context.model.Street,
              StreetNumber: context.model.StreetNumber,
              Floor: context.model.Floor,
              Department: context.model.Department,
              Name: context.model.Name,
              BusinessName: context.model.BusinessName,
              ComercialActivityID: context.model.ComercialActivityID,
              CUIT: context.model.CUIT,
              LandLane: context.model.LandLane,
              TelephoneCompanyID: context.model.TelephoneCompanyID,
              IvaTypeID: context.model.IvaTypeID
            },
            this,
            function(data) {
              if (data.ResponseVM.Resultado) {
                if (!data.ResponseVM.IsMailVerificated) {
                  context.$store.dispatch("logout").then(() => {
                      notificationHelpers.showSuccess("Mis datos", "Se han modificado correctamente sus datos. Por favor, ingrese nuevamente.", context);
                      context.$router.push("login");
                  });  
                }
                else{
                  notificationHelpers.showSuccess(
                  "Exito!",
                  "Se guardaron sus datos correctamente",
                  context
                  );
                }                                
              }              
            }
          );
        } else {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Verifique todos los campos",
            context
          );
        }
      });
    },
    cargarModel() {
        let context = this;
        axiosHelpers.axiosGet(
          "Commerce/MyProfileCommerceGet",
          {},
          this,
          async function(data) {
            // -- Se espera a que carguen las listas para que se tome el valor seleccionado
            await context.cargarListas(context, data);

            context.model = data.ResponseVM;
            context.OldMail = data.ResponseVM.Mail;
            if (context.model.CityID != 0) {
              context.Localidad = {
                ID: context.model.CityID,
                Text: context.model.CityName
              };
            }
            
            context.mostrarFormulario = true;
          }
        );
    },
    cargarListas(context, data){
        context.actividadescomerciales = data.ResponseVM.CommercialActivities;
        context.tiposiva = data.ResponseVM.IvaTypes;
        context.companias = data.ResponseVM.TelephoneCompanies;
    },
    emailValidation(){
      let context = this;

      if (context.isAssociatedCommerce) {
        return;
      }

      //-- Indica si tiene que Verificación de 2 pasos activa
      if (context.$store.getters.ShouldPerformTwoStepVerification == true) {
         context.$router.push({name:"selectSecurityMethod", params:{
                    accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                    useRouterPush: true, dataPost:{name:"EmailValidation", params:{
                    url: "/miperfilc"
            }}
            }});
      } else {
         context.$router.push({name:"EmailValidation", params:{
                    url: "/miperfilc"
            }});
      }
    },
    phoneValidation(){
      let context = this;

      if (context.isAssociatedCommerce) {
        return;
      }

   //-- Indica si tiene que Verificación de 2 pasos activa
      if (context.$store.getters.ShouldPerformTwoStepVerification == true) {
                  context.$router.push({name:"selectSecurityMethod", params:{
                    accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                    useRouterPush: true, dataPost:{name:"PhoneValidation", params:{
                    url: "/miperfilc"
            }}
            }});
      } else{
           context.$router.push({name:"PhoneValidation", params:{
                    Prefix: context.model.Prefix,
                    Telephone:context.model.Telephone,
                    url: "/miperfilc"
            }});
      }
    },
    onValidPin(val){
      let context = this;
      if(val) {
          context.guardar();
      }
    },
    onLoadUsePaymentPin(val){
      let context = this;
      context.usePaymentPin = val;
    },
    pinValidate() {
      let context = this;

      if (context.isAssociatedCommerce) {
        return;
      }

      let newMail = context.model.Mail;
      if(context.usePaymentPin && (newMail != context.OldMail)) {
          context.showModalPinValidation = true;
      } else {
          context.guardar();
      }
    }
  },
  computed: {
    isAssociatedCommerce() {
      return this.$store.getters.isAssociatedCommerce;
    },
    profileImageStyle() {
      return {
        width: "150px",
        cursor: this.isAssociatedCommerce ? "default" : "pointer"
      };
    },
    numerocompleto: function() {
      let prefijo = "";
      let numero = "";

      if (this.model.Prefix != null) {
        prefijo = this.model.Prefix;
      }
      if (this.model.Telephone != null) {
        numero = this.model.Telephone;
      }

      return prefijo + numero;
    },
  },
  mounted: function() {
    let context = this;
    context.isPhoneVerify = context.$store.getters.IsPhoneVerify;

    context.cargarModel();
  },
};
</script>
